import React, { useEffect, useRef, useState } from 'react';
import css from './search-input.module.scss';
import { ReactComponent as SearchIcon } from 'src/assets/search_icon.svg';
import classNames from 'classnames';

interface SearchInputProps {
  id: string;
  name: string;
  initialValue?: string;
  placeholder: string;
  onSearch: (value: string) => void;
  className: string;
  showBtn?: boolean;
}

export default function SearchInput({
  id,
  name,
  initialValue,
  placeholder,
  onSearch,
  className,
  showBtn
}: Readonly<SearchInputProps>) {
  const [value, setValue] = useState(initialValue ?? '');
  const prevValueRef = useRef(value);

  useEffect(() => {
    if (initialValue !== prevValueRef.current) {
      setValue(initialValue ?? '');
      prevValueRef.current = initialValue ?? '';
    }
  }, [initialValue]);

  const handleSearchIconClick = () => onSearch(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value);

  function handleClear() {
    setValue('');
    onSearch('');
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      onSearch((e.target as HTMLInputElement).value);
    }
  }

  return (
    <div className={classNames(css.inputGroup, className ?? '')}>
      <SearchIcon className={css.searchIcon} onClick={handleSearchIconClick} />
      <input
        placeholder={placeholder}
        type='search'
        value={value}
        id={id}
        name={name}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      {value && (
        <button className={css.clear} onClick={handleClear}>
          ×
        </button>
      )}

      {showBtn && value && (
        <button className={css.searchBtn} onClick={handleSearchIconClick}>
          Шукати
        </button>
      )}
    </div>
  );
}
